// extracted by mini-css-extract-plugin
module.exports = {"bdnBadgePreview":"blogTocSidebar_bdnBadgePreview__j9RMT","bdnBadgePop":"blogTocSidebar_bdnBadgePop__1giJp"};